<template>
  <div class="wrapper">
    <div class="col-12 p-0 mb-3">
      <div class="header">
        <h4>
          <span class="icon" style="color: #cccccc;">
            <font-awesome-icon :icon="['fas', 'chart-line']" />
          </span>
          Relatórios em PowerBI
        </h4>
      </div>

      <div class="horozontal-buttons">
        <b-button
          v-for="(item, i) in options"
          :key="i"
          style="border-radius: 0; border: none; background: transparent;"
          @click="setReport(item)"
          :style="{
            borderBottom: viewType === item.text ? '2px solid #4DE594' : 'none',
            color: viewType === item.text ? '#4DE594' : '',
          }"
          >{{ item.text }}</b-button
        >

        <div
          style="
            width: 100%;
            height: 1px;
            border-bottom: solid 2px #e8e8e8;
            margin-top: -2px;
          "
        ></div>
      </div>
    </div>

    <report-pbi
      v-if="reportId && reportGroupId"
      :report-id="reportId"
      :group-id="reportGroupId"
      :filterPaneEnabled="filterPaneEnabled"
      :pageNavigation="pageNavigation"
      :rls="rls"
    ></report-pbi>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import api from '@/services/api';
import reportPbi from '@/components/organisms/report-pbi';

export default {
  components: {
    reportPbi,
  },
  computed: {
    ...mapState('authentication', ['userProfile']),
    ...mapFields('settings', ['country']),
    ...mapState('companies', ['myMetric', 'company']),
  },
  data() {
    return {
      selected: null,
      userAuth: null,
      options: [],
      viewType: null,
      reports: [],
      reportId: null,
      reportGroupId: null,
      filterPaneEnabled: false,
      pageNavigation: false,
      rls: false,
    };
  },
  methods: {
    setReport(item) {
      this.reportId = null;
      this.reportGroupId = null;
      this.filterPaneEnabled = false;
      this.pageNavigation = false;
      this.rls = false;
      this.viewType = item.text;

      setTimeout(() => {
        this.reportId = item.reportId;
        this.reportGroupId = item.reportGroupId;
        this.filterPaneEnabled = item.filterPaneEnabled;
        this.pageNavigation = item.pageNavigation;
        this.rls = item.rls;
      }, 600);
    },
    async getReportsMenu() {
      let { data } = await api.get(`/report-companies`, {
        headers: {
          'x-access-token': this.userAuth.token,
        },
        params: {
          companyId: this.userAuth.companyId,
        },
      });
      const reportCompany = data;
      data = await api.get(`/reports`, {
        headers: {
          'x-access-token': this.userAuth.token,
        },
      });

      const reportProfileData = await api.get('/get-profile-report', {
        headers: {
          'x-access-token': this.userAuth.token,
        },
      });

      const reportProfile = reportProfileData.data.reportsProfile;

      const reportsByProfile = [];

      const reports = data.data.filter((item) => item.reportType === 'powerbi');

      for (let i = 0; i < reports.length; i += 1) {
        const reportName = this.getReportOptionName(reports[i].reportName);

        if (reports[i].reportType === 'powerbi') {
          for (let j = 0; j < reportCompany.length; j += 1) {
            if (reportCompany[j].reportId === reports[i]._id) {
             // profileId admin and master
             if (this.userAuth.profileId !== "5e74d116495c4f4c08aadf34" && this.userAuth.profileId !== "5e74d204495c4f4c08aadf36") {
              for(let a = 0; a < reportProfile.length; a+=1) {
                if (reportProfile[a].profileId.toString() === this.userAuth.profileId.toString()) {
                  if(!reportsByProfile.includes(reportProfile[a].reportId)){
                    reportsByProfile.push(reportProfile[a].reportId)
                  }

                  if(reportsByProfile.includes(reports[i]._id)) {
                    const foundReport = this.options.find(report => report._id === reports[i]._id);

                    if (!foundReport) {
                      this.options.push({
                        value: reports[i].reportName,
                        text: reportName ? reportName : reports[i].reportName,
                        reportId: reports[i].pbiId ? reports[i].pbiId : null,
                        reportGroupId: reports[i].pbiGroupId
                          ? reports[i].pbiGroupId
                          : null,
                        filterPaneEnabled: reports[i].filterPaneEnabled
                          ? reports[i].filterPaneEnabled
                          : false,
                        pageNavigation: reports[i].pageNavigation
                          ? reports[i].pageNavigation
                          : false,
                        rls: reports[i].rls ? reports[i].rls : false,
                        _id: reports[i]._id
                      });
                    }
                  }
                }
              }
             } else {
               this.options.push({
                  value: reports[i].reportName,
                  text: reportName ? reportName : reports[i].reportName,
                  reportId: reports[i].pbiId ? reports[i].pbiId : null,
                  reportGroupId: reports[i].pbiGroupId
                  ? reports[i].pbiGroupId
                  : null,
                  filterPaneEnabled: reports[i].filterPaneEnabled
                  ? reports[i].filterPaneEnabled
                  : false,
                  pageNavigation: reports[i].pageNavigation
                  ? reports[i].pageNavigation
                  : false,
                  rls: reports[i].rls ? reports[i].rls : false,
                  _id: reports[i]._id
                });
              }
              break;
            }
          }
        }
      }
    },

    getReportOptionName(reportKey) {
      const reportNames = this.$i18n.messages[this.$i18n.locale].reports
        .reportTitles;

      for (let i = 0; i < reportNames.length; i += 1) {
        if (reportNames[i].key === reportKey) {
          if (this.myMetric.indexOf('nps') !== -1) {
            return reportNames[i].value;
          } else if (this.myMetric.indexOf('ces') !== -1) {
            return reportNames[i].cesValue;
          } else if (this.myMetric === 'csat-1-5') {
            return reportNames[i].csatValue;
          } else if (this.myMetric === 'csat-1-5(media)') {
            return reportNames[i].csatValueAverage;
          } else if (this.myMetric === '5-stars') {
            return reportNames[i].fiveStarsValue;
          } else if (this.myMetric === 'like-dislike') {
            return reportNames[i].likeDislikeValue;
          }
        }
      }

      return null;
    },
  },
  async created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));

    if (!this.userProfile.permissions.reports.menu) {
      this.$router.push(`/dashboard/${this.userAuth.companyId}`);
    }
  },

  async mounted() {
    await this.getReportsMenu();
    // this.selected = 'Evolução de NPS';
    this.selected = null;

    await this.getReportOptionName();

    if(this.company.homePageIsNotDashboard){
      if(this.options && this.options.length > 0) {
        this.setReport(this.options[0]);
      }
    }
  },
};
</script>
<style lang="scss" scoped>
.wrapper {
  background-color: #fff;
  min-height: 100%;
  padding: 20px;
}

b-button {
  outline: none;
}

.btn:focus {
  outline: none;
  box-shadow: none;
}
.btn {
  box-shadow: none !important;
}
</style>



// WEBPACK FOOTER //
// src/components/organisms/reports/power-bi/index.vue